import AOS from "aos";
import './src/styles/global.css'
import "aos/dist/aos.css";

AOS.init({
    duration: 1000,
    offset: 200,
});